module.exports = __webpack_public_path__ + "img/logo.641cdcdf.png";